var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlesSideBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.05 24H10.95C10.67 24 10.45 23.78 10.45 23.5C10.45 23.22 10.67 23 10.95 23H21.05C21.33 23 21.55 23.22 21.55 23.5C21.55 23.78 21.33 24 21.05 24Z",
    fill: "#201E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.52C13.87 21.52 13.74 21.47 13.65 21.37L8.15 15.87C7.95 15.67 7.95 15.36 8.15 15.16L11.17 12.13C11.36 11.94 11.69 11.94 11.88 12.13L14.01 14.26L20.12 8.15C20.32 7.95 20.63 7.95 20.83 8.15L23.85 11.17C23.94 11.26 24 11.39 24 11.52C24 11.65 23.95 11.78 23.85 11.87L14.36 21.37C14.27 21.46 14.14 21.52 14.01 21.52H14ZM9.21 15.52L14.01 20.32L22.79 11.52L20.47 9.2L14.35 15.32C14.15 15.52 13.84 15.52 13.64 15.32L11.51 13.19L9.19 15.51L9.21 15.52Z",
    fill: "#201E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlesSideBarIcon);
export default __webpack_public_path__ + "static/media/controlesSideBarIcon.0f2a8bc08772aec1dbe53ea1e6f46f08.svg";
export { ForwardRef as ReactComponent };